import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";

const size = {
  width: 160,
  height: 100,
};

const COLORS = ["#4CAF50", "#EF5350", "#3384E8"];

const CenterNumber = styled("text")(() => ({
  fill: "#000",
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 32,
  fontWeight: 700,
}));

const CenterLabel = styled("text")(() => ({
  fill: "grey",
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 14,
  fontWeight: 500,
}));

interface PieCenterLabelPropsB {
  loadedCount: number;
  totalConversion: number;
  selectedActionType: string;
  altIdentifier: number;
  late: number;
}

function PieCenterLabel({ loaded, type }: { loaded: number; type: string }) {
  const { width, height, left, top } = useDrawingArea();
  const centerX = left + width / 2;
  const centerY = top + height / 2;

  return (
    <>
      <CenterNumber x={centerX} y={centerY - 10}>
        {loaded}
      </CenterNumber>
      <CenterLabel x={centerX} y={centerY + 15}>
        Loaded Of {type}'s
      </CenterLabel>
    </>
  );
}

function CustomLegend(data: any) {
  const items = data?.data ?? [];
  const isRowLayout = items.length >= 3; // switch to row if 3 or more

  return (
    <Box
      display="flex"
      flexDirection={isRowLayout ? "row" : "column"}
      flexWrap={isRowLayout ? "wrap" : "nowrap"}
      gap="12px 24px"
      maxWidth={isRowLayout ? "200px" : "unset"} // ensures wrap works nicely
    >
      {items.map((entry: any, index: any) => (
        <Box key={entry.label} minWidth="80px">
          <Typography
            fontWeight={600}
            sx={{
              borderBottom: `1px solid ${COLORS[index]}`,
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            {entry.label}
          </Typography>
          <Box display="flex" alignItems="center" gap="9.74px">
            <Typography
              sx={{ color: COLORS[index], fontWeight: 500, fontSize: "12px" }}
            >
              {entry.count}
            </Typography>
            <Typography
              sx={{ color: COLORS[index], fontSize: "12px", fontWeight: 600 }}
            >
              {entry.percent}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default function FtdLoadedPieChartB({
  loadedCount,
  totalConversion,
  altIdentifier,
  selectedActionType,
  late,
}: PieCenterLabelPropsB) {
  const data = [
    {
      label: "Normal",
      count: loadedCount - late - altIdentifier,
      percent: `${(
        ((loadedCount - late - altIdentifier) / totalConversion) *
        100
      )?.toFixed(2)}%`,
    },
    {
      label: "Late",
      count: `${late}`,
      percent: `${((late / totalConversion) * 100)?.toFixed(2)}%`,
    },
    {
      label: "Alt. Identifier",
      count: `${altIdentifier}`,
      percent: `${((altIdentifier / totalConversion) * 100)?.toFixed(2)}%`,
    },
  ];

  const pieChartData = data?.map((item, index) => ({
    label: item.label,
    value: item.count,
    color: COLORS[index],
  }));

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={"center"}
      maxWidth={360}
      // sx={{
      //   "@media (max-width:1600px)": {
      //     flexDirection: "column",
      //   },
      // }}
    >
      <PieChart
        sx={{ width: "60% !Important" }}
        margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
        series={[
          {
            data: pieChartData,
            innerRadius: 80,
            outerRadius: 60,
          } as any,
        ]}
        {...size}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
      >
        <PieCenterLabel
          loaded={loadedCount}
          type={selectedActionType} /* type={selectedActionType} */
        />
      </PieChart>
      <CustomLegend data={data} />
    </Stack>
  );
}
